<template>
  <transition name="slide-fade">
    <div class="login">
      <div class="login-bg"></div>

      <transition name="slide-fade">
        <main class="main" v-if="!isForgotPassword">
          <a href="http://microba.com">
            <img src="~@/assets/images/logo-full-mono-light.png" alt>
          </a>
          <h1>Sign in</h1>

          <div class="box">
            <transition name="slide-fade">
              <div
                v-if="fromVerify && !loginError"
                class="alert alert-success"
                role="alert"
              >Thank you for verifying your account. Please sign in below.</div>
            </transition>

            <transition name="slide-fade">
              <div v-if="loginError" class="alert alert-danger" role="alert">{{humanLoginError}}</div>
            </transition>

            <transition name="slide-fade">
              <div
                v-if="passwordResetSuccess"
                class="alert alert-success"
                role="alert"
              >We've sent you an email with a link to reset your password</div>
            </transition>

            <div
              class="form-group has-feedback has-feedback-left"
              :class="{ 'has-danger' : errors.has('email') }"
            >
              <label class="form-control-label hidden" for="inputEmail">Email</label>
              <div class="input-icon">
                <span class="oi oi-envelope-closed"></span>
              </div>
              <input
                type="email"
                class="form-control form-control-danger"
                v-model="email"
                name="email"
                placeholder="Email"
              >
            </div>

            <div class="form-group">
              <div class="input-icon">
                <span class="oi oi-lock-locked"></span>
              </div>
              <input
                class="form-control"
                v-model="password"
                type="password"
                v-on:keyup.enter="login"
                required
                placeholder="Enter password"
              >
            </div>

            <div class="row suplimentary">
              <div class="col-12 col-md-6">
                <div class="radio-wrapper-outer">
                  <div class="radio-wrapper-inner">
                    <div class="form-checkbox">
                      <input type="checkbox" v-model="rememberMe" id="rememberMe" value="false">
                      <label for="rememberMe">Remember me</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <button class="plain" v-on:click="isForgotPassword = true">Forgot your password?</button>
              </div>
            </div>

            <div class="row text-center">
              <Button
                :disabled="!email || !password"
                class="mb-0" 
                text="Sign in" 
                :loading="loginLoading"
                @onClick="login"/>
            </div>

            <div class="row text-center no-account additional-info">
              <div class="col-12 text-center">
                <router-link to="register" class="text-center btn btn-outline-primary mt-3">
                  <span class="text-muted">Don't have an account?</span> Create one
                </router-link>
              </div>
            </div>
          </div>

          <footer class="additional-info">
            <p>
              By logging in, you are agreeing to our
              <a
                href="https://www.microba.com/wp-content/uploads/2018/12/Microba-Terms-Conditions-v2.8.pdf"
                target="_blank"
              >Terms & Conditions</a> and
              <a
                href="https://www.microba.com/wp-content/uploads/2018/07/Microba-Pty-Limited-Privacy-Policy.pdf"
                target="_blank"
              >Privacy Policy</a>
            </p>
          </footer>
        </main>
      </transition>

      <transition name="slide-fade">
        <main v-if="isForgotPassword" class="main forgot-password">
          <a style="cursor: pointer">
            <img
              src="~@/assets/images/logo-full-mono-light.png"
              alt
              v-on:click="isForgotPassword = false"
            >
          </a>

          <h1>Reset your password</h1>

          <div class="box">
            <transition name="slide-fade">
              <div
                v-if="passwordResetError"
                class="alert alert-danger"
                role="alert"
              >Email address could not be found.</div>
            </transition>

            <div
              class="form-group has-feedback has-feedback-left col-12"
              :class="{ 'has-danger' : errors.has('email') }"
            >
              <label class="form-control-label hidden" for="inputEmail">Email</label>
              <div class="input-icon">
                <span class="oi oi-envelope-closed"></span>
              </div>
              <input
                type="email"
                :class="{ 'is-invalid' : errors.has('email') && fields.email.touched }"
                class="form-control"
                v-validate="'required|email'"
                data-vv-as="email"
                v-model="email"
                name="email"
                id="inputEmail"
                placeholder="Email"
              >
              <div class="invalid-feedback d-block" v-if="isForgotError">A valid email is required</div>
              <!--<small class="form-text text-muted">We'll never share your email with anyone else.</small>-->
            </div>

            <div class="row">
              <Button
                v-if="isLoading == false"
                text="Reset Password"
                :loading="passwordResetLoading"
                @onClick="resetPassword"
              />
            </div>

            <div class="row text-center no-account additional-info">
              <div class="col-12">
                <p class="text-center">
                  <a v-on:click="isForgotPassword = false">Return to Sign In page</a>
                </p>
              </div>
            </div>
          </div>
        </main>
      </transition>
    </div>
  </transition>
</template>

<script>
/* eslint-disable */
import Button from "@/components/elements/DynamicButton.vue"

export default {
  name: "Login",
  components: {
    Button
  },
  data() {
    return {
      isLoading: false,
      email: "",
      password: "",
      rememberMe: false,
      isLoginError: false,
      isForgotPassword: false,
      isForgotError: false,
      passwordResetSuccess: null,
      passwordResetError: null,
      passwordResetLoading: false
    }
  },
  methods: {
    login() {
      this.isLoginError = false
      this.$store
        .dispatch("login", {
          email: this.email,
          password: this.password
        })
        .catch(error => {
          this.isLoginError = true
          console.log("login error", error)
        })
    },

    resetPassword() {
      this.isForgotError = false
      this.passwordResetSuccess = null
      this.passwordResetError = null
      if (this.email.length < 1) {
        this.isForgotError = true
      }

      if (this.isForgotError) {
        return
      }
      this.passwordResetLoading = true
      this.$store.dispatch("getPasswordReset", this.email)
      .then(() => {
        this.passwordResetSuccess = true
      })
      .catch(error => {
        this.passwordResetError = true
      })
      .finally(() => {
        this.passwordResetLoading = false
      })
    }
  },

  computed: {
    humanLoginError() {
      if (this.loginError.includes("unauthorized")) {
        return "Email address could not be found."
      } else if (this.loginError.includes("Bad credentials")) {
        return "Incorrect password entered"
      } else if (this.loginError.includes("locked")) {
        return "Your account has not been verified. Please check your email and follow the instructions."
      }

      return this.loginError
    },

    loginError: function() {
      return this.$store.state.POST_LOGIN_FAILURE
    },
    loginLoading: function() {
      return this.$store.state.POST_LOGIN_PENDING
    },
    fromVerify: function() {
      return this.$route.query.fromVerify == 1
    }
  },

  watch: {
    passwordResetSuccess: function() {
      this.isForgotPassword = false
    }
  }
}
</script>

<style lang='scss' scoped>
body {
  background: white;
}

.radio-wrapper-outer {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1rem 0rem 1rem 0rem;

  @media (min-width: 768px) {
    justify-content: flex-start;
    padding: 0;
  }
}

.radio-wrapper-inner {
  display: block;
}

.forgot-password {
  .row.suplimentary {
    padding-top: 1.5rem;

    @media (min-width: 768px) {
      padding-top: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/application/customer/Login.vue